import React from 'react';
import { Label } from 'components/lib';
import Style from './checkbox.module.scss';

export function Checkbox(props){

  return (
    <div 
    className={ Style.checkbox } 
    style={{ 
      position: props.embedded ? 'absolute' : null, 
      top: props.embedded ? '0px' : null,
      right: props.embedded ? '-39px' : null
      }}
    >
      <input
        type='checkbox'
        name={ props.name }
        id={ props.option }
        value={ props.option }
        checked={ props.checked ? 'checked' : '' }
        onChange={ e => props.callback(props.index, props.checked, props.option)}
      />

      <Label
        text={ props.option }
        required={ props.required }
        for={ props.option }
        type='check'
      />
    </div>
  );
}
